// imports section Start
import React, { useState, useEffect, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  externalgetApi,
  externalpostApi,
} from "../../../services/external/externalApis";
import { COMMON_API_04, COMMON_API_05 } from "../../../api/ApiModel";
import { styled, useTheme } from "@mui/material/styles";
import { useStyles } from "../../../assets/styles/Theme";
import DeleteIcon from "@mui/icons-material/Delete";
import {
  Box,
  Grid,
  Typography,
  Paper,
  Button,
  IconButton,
  Stack,
  TextField,
  MenuItem,
  Card,
  CardContent,
} from "@mui/material";
import { addCheque, deleteCheque } from "../../../store/ReduxChequeSlice";
// imports section End

// const Item = styled(Paper)(({ theme }) => ({
//   width: "100%",
//   padding: "4px",
// }));

function CashierCheque({ formData = {}, setFormData }) {
  // Hooks start
  const theme = useTheme();
  const styles = useStyles(theme);
  const [value, setValue] = React.useState("one");
  const dispatch = useDispatch();
  const [banks, setBanks] = useState([]);
  const [selectedBank, setSelectedBank] = useState("");
  const [branches, setBranches] = useState([]);
  const [selectedBranch, setSelectedBranch] = useState("");
  const [error, setError] = useState(null);
  const [payments, setPayments] = useState([]);
  const chequeList = useSelector((state) => state.cheques.chequeList);

  useEffect(() => {
    fetchBanks();
  }, []);

  useEffect(() => {
    fetchBranches();
  }, [selectedBank]);

  // Hooks end

  // Handlers start
  const formatPrice = (price) => {
    return new Intl.NumberFormat("en-US", {
      // style: "currency",
      // currency: "LKR",
    }).format(price);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    const nameParts = name.split("."); // Split the name by '.' to handle nested fields

    setFormData((prev) => {
      const updatedFormData = { ...prev };

      // Initialize the "deposit" object if it's undefined
      if (!updatedFormData.deposit) {
        updatedFormData.deposit = {};
      }

      // Check the length of nameParts to handle nested fields
      if (nameParts.length === 2) {
        updatedFormData.deposit[nameParts[1]] = value; // Handle "deposit.chequename"
      } else if (nameParts.length === 3) {
        if (!updatedFormData.deposit[nameParts[1]]) {
          updatedFormData.deposit[nameParts[1]] = {}; // Ensure cheque object exists
        }
        updatedFormData.deposit[nameParts[1]][nameParts[2]] = value; // Handle "deposit.cheque.chequename"
      } else {
        updatedFormData[nameParts[0]] = value;
      }

      return updatedFormData;
    });
  };

  // Handle bank selection and update form data
  const handleBankChange = (event) => {
    const { value } = event.target;
    setSelectedBank(value);
    setFormData((prev) => ({
      ...prev,
      deposit: {
        ...prev.deposit,
        cheque: {
          ...prev.deposit.cheque,
          chequebank: value,
        },
      },
    }));
    setBranches([]); // Reset branches when changing bank
  };

  // Handle branch selection and update form data
  const handleBranchChange = (event) => {
    const { value } = event.target;
    console.log(value); // Log the selected branch code
    setSelectedBranch(value);
    setFormData((prev) => ({
      ...prev,
      deposit: {
        ...prev.deposit,
        cheque: {
          ...prev.deposit.cheque,
          chequebranch: value,
        },
      },
    }));
  };

  const handleAddPayment = () => {
    // Add cheque to Redux state
    dispatch(addCheque(formData.deposit.cheque));

    // Clear the cheque form data after adding it
    setFormData((prev) => ({
      ...prev,
      deposit: {
        ...prev.deposit,
        cheque: {}, // Reset only the 'cheque' field
      },
    }));
  };

  const handleDeletePayment = (index) => {
    // Remove card by index from Redux state
    dispatch(deleteCheque(index));
  };
  // Handlers end

  // API calls start
  // Fetch banks on component mount

  const fetchBanks = async () => {
    try {
      const response = await externalgetApi(COMMON_API_04, "GET");
      setBanks(response);
    } catch (error) {
      console.error("Error fetching banks:", error);
      setError(error);
    }
  };

  // Fetch branches based on selected bank

  const fetchBranches = async () => {
    if (selectedBank) {
      try {
        const params = { BANKCODE: selectedBank };
        const response = await externalgetApi(COMMON_API_05, "GET", params);
        setBranches(response); // Assuming response is the array of branches
      } catch (error) {
        console.error("Error fetching branches:", error);
        setError(error);
      }
    }
  };

  // API calls end

  return (
    <Box sx={styles.cs_cash}>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
          <Typography
            sx={{ ...theme.typography.h2, color: theme.palette.text.primary }}
          >
            Cheque Deposit
          </Typography>
        </Grid>
        <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
          <TextField
            label="Name"
            name="deposit.cheque.chequename"
            variant="outlined"
            fullWidth
            size="small"
            value={formData?.deposit?.cheque?.chequename || ""}
            onChange={handleChange}
          />
        </Grid>

        <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
          <TextField
            label="Amount"
            name="deposit.cheque.chequeamount"
            variant="outlined"
            fullWidth
            size="small"
            value={formData?.deposit?.cheque?.chequeamount || ""}
            onChange={handleChange}
          />
        </Grid>
        <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
          <TextField
            select
            label="Bank"
            name="deposit.cheque.chequebank" // Nested in the "deposit" object
            value={formData?.deposit?.cheque?.chequebank || ""}
            onChange={handleBankChange}
            size="small"
            fullWidth
          >
            {banks.map((bank) => (
              <MenuItem key={bank.BANKCODE} value={bank.BANKCODE}>
                {bank.BANKNAME}
              </MenuItem>
            ))}
          </TextField>
        </Grid>
        <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
          <TextField
            select
            label="Branch"
            name="deposit.cheque.chequebranch"
            value={formData?.deposit?.cheque?.chequebranch || ""}
            onChange={handleBranchChange}
            size="small"
            fullWidth
            disabled={!selectedBank}
          >
            {branches.map((branch) => (
              <MenuItem key={branch.BRANCHCODE} value={branch.BRANCHCODE}>
                {branch.BRANCHNAME}
              </MenuItem>
            ))}
          </TextField>
        </Grid>
        {/* <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
          <TextField
            id="outlined-basic"
            label="Remark"
            variant="outlined"
            fullWidth
            size="small"
          />
        </Grid> */}
        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
          <Button
            variant="contained"
            size="medium"
            sx={styles.btn_primary}
            fullWidth
            onClick={handleAddPayment}
          >
            Add New
          </Button>
        </Grid>
      </Grid>

      <hr sx={{ ...styles.border_bottom }}></hr>

      <Box pt={2}>
        <Stack spacing={2}>
          {chequeList.map((payment, index) => (
            <Card
              key={index}
              sx={{
                borderRadius: 2,
                boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
                padding: "12px",
                backgroundColor: theme.palette.background.default,
                alignItems: "center",
                pt: 0,
              }}
            >
              <CardContent>
                <Grid
                  container
                  spacing={2}
                  display={"flex"}
                  alignItems={"center"}
                >
                  <Grid
                    item
                    xs={12}
                    sm={4}
                    display={"flex"}
                    flexDirection={"column"}
                  >
                    <Typography variant="caption">Name</Typography>
                    <Typography variant="sub_title" fontWeight={600}>
                      {payment.chequename}
                    </Typography>
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={3}
                    display={"flex"}
                    flexDirection={"column"}
                  >
                    <Typography variant="caption">Bank</Typography>
                    <Typography variant="sub_title" fontWeight={600}>
                      {payment.chequebank}
                    </Typography>
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={3}
                    textAlign={"right"}
                    display={"flex"}
                    flexDirection={"column"}
                  >
                    <Typography variant="caption">Amount</Typography>
                    <Typography variant="sub_title" fontWeight={600}>
                      {formatPrice(payment.chequeamount)}
                    </Typography>
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={2}
                    display={"flex"}
                    justifyContent={"flex-end"} // Align button to the right
                    alignItems={"center"}
                  >
                    <IconButton
                      onClick={() => handleDeletePayment(index)}
                      sx={{
                        ...styles.cs_cash_delete_icon,
                      }}
                    >
                      <DeleteIcon />
                    </IconButton>
                  </Grid>
                </Grid>
              </CardContent>
            </Card>
          ))}
        </Stack>

        {/* 
        <Grid gap={2} sx={styles.btn_group_bootom_align}>
          <Button sx={styles.btn_secondary} size="medium" variant="outlined">
            Cancel
          </Button>
          <Button sx={styles.btn_primary} size="medium" variant="contained">
            Continue Payment
          </Button>
        </Grid> */}
      </Box>
    </Box>
  );
}
export default CashierCheque;
